import { searchAssets, useUserContext } from "@dexteel/mesf-core";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useWorkOrdersContext } from "../context/workOrdersContext";

export const useInitializeWorkOrders = () => {
  const navigate = useNavigate();
  const [filtersLoaded, setFiltersLoaded] = useState(false);
  const {
    state: { defaultAreaId },
  } = useUserContext();

  const { actions } = useWorkOrdersContext();
  const { data: allAssets } = searchAssets();

  const params = useParams();

  useEffect(() => {
    if (allAssets && allAssets.length > 0) {
      setFiltersLoaded(true);
    }
  }, [allAssets]);

  useEffect(() => {
    if (filtersLoaded) {
      if (params.AssetIdParam) {
        actions.setAssetIdWorkOrders(params.AssetIdParam);
        actions.setAssetSearchNameWorkOrders(
          allAssets?.find(
            (asset) => asset.AssetId === Number.parseInt(params.AssetIdParam!)
          )?.AssetName || "Unknown"
        );
      } else if (defaultAreaId !== undefined && defaultAreaId !== null) {
        actions.setAssetIdWorkOrders(defaultAreaId);
        actions.setAssetSearchNameWorkOrders(
          allAssets?.find((asset) => asset.AssetId === defaultAreaId)?.AssetName
        );
        if (defaultAreaId !== 0) {
          navigate(`/work-orders/${defaultAreaId}`, { replace: true });
        } else {
          navigate(`/work-orders`, { replace: true });
        }
      }
    }
  }, [JSON.stringify(params), filtersLoaded, allAssets, defaultAreaId]);
};
